import propTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { SlidersVertical } from 'lucide-react';
import { DefaultSheet, SheetBody, SheetFooter, Button, FormGroup, Label, Row, Col, Switch, DefaultTooltip, ButtonIcon } from 'twyne-new.ui';

import { Select } from '@Components/pure/form-fields/Select';
import { useSelectOptions } from '@Stores/base-factories/store-list';

import { usePathStore } from '../../store';

const TYPE_OPTIONS = [
  { label: "Account Password", value: "account-pw" },
  { label: "HTML", value: "html" },
  { label: "iframe", value: "iframe" },
  { label: "Covalent", value: "partner-covalent" },
  { label: "Ifficient", value: "partner-ifficient" },
  { label: "Nitro", value: "partner-nitro" },
  { label: "Fluent", value: "partner-fluent" },
  { label: "Opt-Intelligence", value: "partner-optintelligence" },
  { label: "Permission Data", value: "partner-permissiondata" },
  { label: "RexAdz", value: "partner-rexadz" },
  { label: 'React2Media', value: 'partner-react2' },
  { label: "Tiburon", value: "partner-tiburon" },
  { label: "Twyne", value: "partner-twyne" },
  { label: "TCPA Confirmation", value: "tcpa-confirmation" },
  { label: "TCPA Question", value: "tcpa-question" },
  { label: "TCPA Form", value: "tcpa-form" },
  { label: 'TCPA Linkout Question', value: 'tcpa-linkout-question' },
  { label: 'TCPA ClickToCall Question', value: 'tcpa-call-question' },
  { label: 'TCPA Question Custom', value: 'tcpa-question-custom' },
]

export default function PageFilters({ onChangeFilters, filters }) {
  const { active: activeState, type: typeState, rules: rulesState, cfid_number } = filters
  const { lists: { customFields } } = usePathStore()
  const customFildsOptions = useSelectOptions(customFields)
  const [isOpen, setIsOpen] = useState(false)
  const [active, setActive] = useState(activeState)
  const [type, setType] = useState(typeState)
  const [rules, setRules] = useState(rulesState)
  const [customField, setCustomField] = useState(cfid_number)

  useEffect(() => {
    setActive(activeState)
    setType(typeState)
    setRules(rulesState)
    setCustomField(cfid_number)
  }, [activeState, typeState, rulesState, cfid_number, isOpen])

  const handleToogle = () => setIsOpen(prevIsOpen => !prevIsOpen)

  const handleApply = () => {
    const filters = { active, type, rules, cfid_number: customField }
    const terms = []
    for (const [key, value] of Object.entries(filters)) {
      if ((Array.isArray(value) && value.length === 0) || value === null || value === undefined) {
        delete filters[key]
        continue
      }
      terms.push(`${key}=${JSON.stringify(value)}`)
    }

    onChangeFilters({ filterParam: terms.join(' '), pageFilters: filters })
    handleToogle()
  }

  return <>
    <DefaultSheet
      wrapperProps={{ open: isOpen, onOpenChange: handleToogle }}
      trigger={<ButtonIcon content='Filter Pages'>
        <SlidersVertical size={16} className='cursor-pointer' />
      </ButtonIcon>}
      title='Filter Pages'
    >
      <SheetBody>
        <Row>
          <Col size='12'>
            <FormGroup>
              <Label>Type</Label>
              <Select value={type} options={TYPE_OPTIONS} multi onChange={option => setType(option.map(option => option?.value))} />
            </FormGroup>
          </Col>
          <Col size='8'>
            <FormGroup>
              <Label>Custom Field</Label>
              <Select value={customField} options={customFildsOptions} onChange={option => setCustomField(option?.value || null)} />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Active</Label>
              <Switch
                name="active"
                value={active}
                onChange={e => setActive(e.target.checked)}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>With Rules</Label>
              <Switch
                name="rules"
                value={JSON.stringify(rules) === '{"$not":null}'}
                onChange={e => setRules(e.target.checked ? JSON.parse('{"$not":null}') : JSON.parse('{"$eq":null}'))}
              />
            </FormGroup>
          </Col>
        </Row>
      </SheetBody>
      <SheetFooter>
        <Button variant='ghost' onClick={handleToogle}>
          Close
        </Button>
        <Button color="accent" onClick={handleApply}>
          Apply
        </Button>
      </SheetFooter>
    </DefaultSheet>
  </>
}

PageFilters.propTypes = {
  onChangeFilters: propTypes.func,
  filters: propTypes.any,
}
PageFilters.defaultProps = {}
